<template>
  <div class="row" id="gauges-row" v-if="performance && availablity && quality">
    <div class="col-12">
      <BarChart style=" width: 100%; height: 100%"
                ref="periodChart"
                :chartData="getOEEChartData"
                :options="getOptions()"/>
    </div>
  </div>
  <ComponentLoadSpinnerV2 v-else :loading="true"/>
</template>

<script>
import BarChart from "@/components/oeeAnalytics/charts/barChart";
import ComponentLoadSpinnerV2 from "@/components/general/ComponentLoadSpinnerV2";
import oeeCalculations from "@/mixins/oeeAnalytics/oeeCalculations";
import {mapGetters} from "vuex";
import colours from "@/mixins/oeeAnalytics/colours";

export default {
  name: "OEEEBarchartsStacked",
  props: ['availablity', 'performance','quality'],
  mixins: [oeeCalculations, colours],
  components: {
    BarChart,
    ComponentLoadSpinnerV2
  },
  computed: {
    ...mapGetters('oeeAnalytics', ['getWorkflowId', 'getSelectedDate', 'getUnit', 'getDateRange']),
    getOEEChartData() {
      const oeeData = this.getOeeDataPerDateUnit(this.availablity, this.performance,this.quality, this.getDateRange.fromDate, this.getDateRange.toDate, this.getUnit);
      const performanceData = this.getPerformanceDataPerDateUnit(this.performance, this.getDateRange.fromDate, this.getDateRange.toDate, this.getUnit);
      const availabilityData = this.getAvailabilityDataPerDateUnit(this.availablity, this.getDateRange.fromDate, this.getDateRange.toDate, this.getUnit);
      const qualityData = this.getQualityPerDateUnit(this.quality, this.getDateRange.fromDate, this.getDateRange.toDate, this.getUnit)
      const xAxes = this.getUnitDates(this.getDateRange.fromDate, this.getDateRange.toDate, this.getUnit);



      return {
        labels: _.map(xAxes, axisValue => {
          if (this.getUnit == 'day') {
            return moment(axisValue).format('DD-MM-YYYY')
          } else if (this.getUnit === 'week') {
            return `Week ${moment(axisValue).week()}`
          } else if (this.getUnit === 'month') {
            return moment(axisValue).format('MM-YYYY')
          } else if (this.getUnit === 'year') {
            return moment(axisValue).format('YYYY')
          } else {
            return moment(axisValue).format('HH:mm:ss DD-MM-YYYY')
          }
        }),
        datasets: [
          {
            label: this.$t('oeeAnalytics.oeeCharts.gauges.oee'),
            data: _.map(oeeData, data => {
              const oee = data.oee * 100

              return {y: oee, actualValue: _.round(oee, 0)}
            }),
            backgroundColor: this.getOeeColours('oee'),
            xAxes,
            hoverOffset: 4
          }, {
            label: this.$t('oeeAnalytics.oeeCharts.gauges.quality'),
            data: _.map(qualityData, (data) => {

              let quality = data.quality * 100
              return {
                y: quality > 0 ? (100 - quality) : 0,
                actualValue: _.round(quality > 0 ? quality : 0, 0)
              }
            }),
            backgroundColor: this.getOeeColours('quality'),
            xAxes,
            hoverOffset: 4
          },

          {
            label: this.$t('oeeAnalytics.oeeCharts.gauges.performance'),
            data: _.map(performanceData, (data, index) => {
              const performance = data.performance * 100
              return {
                y: performance > 0 ? (100 - performance < 0 ? 0 : 100 - performance) : 0,
                actualValue: _.round(performance, 0)
              }
            }),
            backgroundColor: this.getOeeColours('performance'),
            xAxes,
            hoverOffset: 4
          },
          {
            label: this.$t('oeeAnalytics.oeeCharts.gauges.availability'),
            data: _.map(availabilityData, data => {
              const availability = data.availability * 100
              return {y: availability > 0 ? 100 - availability : 0, actualValue: _.round(availability, 0)}

            }),
            backgroundColor: this.getOeeColours('availability'),
            xAxes,
            hoverOffset: 4
          },


        ]
      };
    },
    getDefaultOptions() {
      const self = this
      return {

        animation: {
          duration: 0 // general animation time
        },
        hover: {
          animationDuration: 100,
          intersect: false,// duration of animations when hovering an item
        },
        legend: {
          display: false,
        },

        title: {
          display: true,
          fontSize: 108,
          fontStyle: 'normal',
          position: 'bottom',
        },
        scales: {
          xAxes: [{
            stacked: true,
            gridLines: {
              display: false
            },
            ticks: {
              display: true //this will remove only the label
            }
          }],
          yAxes: [{
            stacked: true,
            display: true, //this will remove all the y-axis grid lines
            ticks: {
              max: 100,
              display: true //this will remove only the label
            }
          }]
        },
        tooltips: {
          callbacks: {
            title: function (tooltip) {
              return tooltip[0].label
            },
            label: function (tooltipItem) {
              let dataObject = self.getOEEChartData.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]
              return `   ${dataObject.actualValue}% `
            }
          }
        },
        plugins: {
          datalabels: {
            formatter: function (value, context) {
              return ''
              if (context.dataset.data.length > 20) {
                return ''
              }
              return value > 0 ? value + '%' : '';
            },
            color: 'white',
            fontFamily: 'Open Sans',
            anchor: 'end',
            align: 'start',
            font: {
              weight: 'bold',
              size: 14
            },
            offset: 0,
          }
        },
        responsive: true,
        maintainAspectRatio: false,
        onClick: (evt, elements) => {
          var chart = this.$refs.periodChart.$data._chart;
          const chartIndex = chart.getElementAtEvent(evt);
          if (chartIndex.length !== 0) {
            const datasetIndex = chartIndex[0]._datasetIndex;
            const position = chartIndex[0]._index;
            const info = {
              datasetIndex: datasetIndex,
              valueIndex: position,
              label: chart.tooltip._data.labels[position],
              date: chart.tooltip._data.datasets[datasetIndex].xAxes[position],
              value: chart.tooltip._data.datasets[datasetIndex].data[position]
            };
            this.$emit('chartClicked', info);
          } else {
            console.log("Background clicked");
          }
        },
        onHover: (event, chartElement) => {
          event.target.style.cursor = chartElement[0] ? 'pointer' : 'default';
        },
      }
    },


  },
  methods: {
    getOptions(options) {
      return {
        ...this.getDefaultOptions,
        title: {
          display: true,
          fontSize: 18,
          fontStyle: 'normal',
          position: 'bottom',
        }
      }
    },
  }
}
</script>

<style scoped>
#gauges-row {
}

.loading {
  background-color: #efefef;
  height: 100%;
  width: 100%;
  min-height: 250px;
}

</style>